import errorReporter from '@app/errorReporter';

angular.module('bb.external').component('bbExternalBook', {
  bindings: {},
  controller: ExternalBookController,
  controllerAs: 'vm',
  template: `
      <bb-loading has-loaded="vm.actionProcessed">
        <appointment-book
          ng-if="vm.auth.retsDashboard || vm.auth.coopDashboard"
          ext-auth="vm.auth"
          set-ext-auth="vm.setAuth"
        />
      </bb-loading>
    `,
});

ExternalBookController.$inject = [
  '$q',
  '$routeParams',
  'AlmanacService',
  'ExternalAuth',
  'ToastService',
];

function ExternalBookController(
  $q,
  $routeParams,
  AlmanacService,
  ExternalAuth,
  ToastService,
) {
  const vm = this;
  vm.dashboard = true;
  vm.auth = ExternalAuth.auth;
  vm.setAuth = ExternalAuth.setAuth;
  // Get uid from MLS user
  // Get MLS USER
  // Massage user object for appointment booking component
  // Display appointment-book component accordingly

  vm.$onInit = () => {
    const { action, appointmentId, errorMessage } = $routeParams;

    if (errorMessage) {
      ToastService.add({
        message: `Could not sync calendar: ${errorMessage}`,
        type: 'danger',
      });
      vm.actionProcessed = true;
      return;
    }

    const isSyncRequired =
      vm.auth.retsDashboard && appointmentId && action === 'sync';

    if (!isSyncRequired) {
      vm.actionProcessed = true;
      return;
    }

    // Handle automatic sync action after authenticating from a rets dashboard
    const { dashboardId, retsId } = vm.auth;
    const almanacPromises = [
      // Find if user is already authenticated through Nylas
      AlmanacService.getAuthStatus({ dashboardId, retsId }),
      // Find if user already has a calendar event for this appointment
      AlmanacService.findAlmanacEvent({ dashboardId, retsId }, appointmentId),
    ];

    $q.all(almanacPromises)
      .then(([{ isAuthenticated }, { eventId }]) => {
        vm.isAlmanacAuthenticated = isAuthenticated;
        vm.existingAlmanacEvent = eventId;

        if (isAuthenticated && !eventId)
          vm.handleAutomaticCalendarSync(appointmentId);
      })
      .catch(({ data: error }) => {
        ToastService.add({
          message: `Almanac error: ${error.message}`,
          type: 'danger',
        });
      })
      .finally(() => {
        vm.actionProcessed = true;
      });
  };

  vm.handleAutomaticCalendarSync = appointmentId => {
    const { retsId } = vm.auth;
    AlmanacService.createEvent({ retsId }, appointmentId)
      .then(() => {
        swal({
          title: 'Showing successfully synced to calendar!',
          type: 'success',
        });
      })
      .catch(err => {
        errorReporter.error(err);
        swal({
          title:
            'Error: Failed to sync event. Please try again from the coop dashboard',
          type: 'error',
        });
      });
  };
}
